// extracted by mini-css-extract-plugin
export var label = "_e8-5";
export var slideContainer = "_e8-0";
export var slider = "_e8-1";
export var sliderLg = "_e8-4";
export var sliderMd = "_e8-3";
export var sliderSm = "_e8-2";